export default __webpack_public_path__ + "static/media/3-small.8d6585e8.png";